import { Divider, Modal, ModalClose, ModalDialog, Typography } from '@healthinal/ui';
import { LabOrderDto } from '../../../api/generated/model';
import { LabOrderCard } from './LabOrderCard.tsx';

export function LabOrderDetailsDialog({
  open,
  onClose,
  labOrder,
  onEditDialogClose,
}: {
  open: boolean;
  onClose: () => void;
  labOrder: LabOrderDto;
  onEditDialogClose?: () => void;
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ width: 1000, overflowY: 'scroll' }}>
        <ModalClose />
        <Typography level={'h4'}>Resultat</Typography>
        <Divider />
        <LabOrderCard order={labOrder} onEditDialogClose={() => onEditDialogClose && onEditDialogClose()} />
      </ModalDialog>
    </Modal>
  );
}
